<template>
  <div>
    <div v-if="isLoading" class="w-full relative" style="height: 80px;">
      <b-loading :is-full-page="false" :active="true" :can-cancel="false" />
    </div>

    <div v-else-if="!chapters.length" class="has-text-centered w-full mt-4">{{ $t('no_results') }}</div>

    <!-- Una grafica por capitulo -->
    <div class="w-full mt-4" v-for="chapter in chapters" :key="'tag_scurve_' + chapter.id">
      <div v-if="chapter.units.length > 1" class="text-xs text-right pr-2" style="color: orange;">
        {{ $t('s_curve_mixed_units', [chapter.units.join(', ')]) }}
      </div>
      <group-progress-chart
        :group="withUnits(chapter)"
        :level="0"
        :main-chart-colors="chartColors"
        :show-title-prefix="false"
        suffix=""
        :max="null"
      />
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import GroupProgressChart from './group-progress-chart.vue'

export default {
  name: 'dashboard-tags-scurve',

  components: {
    GroupProgressChart,
  },

  props: {
    projectId: { type: Number, required: true },
  },

  data() {
    return {
      chapters: [],
      isLoading: true,
      chartColors: ['#284ec0', '#8c1a94', '#d12411'], // inicial, final, ejecutado
    }
  },

  mounted() {
    this.getChapters()
  },

  methods: {
    // Unidad en el titulo
    withUnits(chapter) {
      return chapter.units.length === 1 ? { ...chapter, name: `${chapter.name} (${chapter.units[0]})` } : chapter
    },

    async getChapters() {
      this.isLoading = true
      try {
        const { data } = await axios.get(`/api/v2/project/${this.projectId}/dashboard/tagscurve`, {
          params: { location_id: 0, status_id: 1 },
        })
        if (data && data.success) {
          this.chapters = data.data
        } else {
          this.$notify.error('error_loading_data')
        }
      } catch (e) {
        this.$notify.error('error_loading_data')
      } finally {
        this.isLoading = false
      }
    },
  },
}
</script>
